import { Breadcrumb, BreadcrumbItem, BreadcrumbLink } from "@chakra-ui/react";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useGlobalContext } from "./useGlobalContext";

type Title =
  | {
      to: string;
      text: string;
    }
  | string;

const getTitle = (data) => {
    if (typeof data === "string") {
        return data;
    }

    if (Array.isArray(data)) {
        return (
            <Breadcrumb>
                { data
                    .map((item) => {
                        if (typeof item === "string") {
                            return item;
                        } else {
                            return <Link to={ item.to }>{ item.text }</Link>;
                        }
                    })
                    .map((item) => (
                        <BreadcrumbItem>
                            <BreadcrumbLink>{ item }</BreadcrumbLink>
                        </BreadcrumbItem>
                    )) }
            </Breadcrumb>
        );
    }
};

type DashboardTitle = {
  title: [string, (data: Title[]) => void];
};

export const useDashboardTitle = (defaultTitle?: string) => {
    //   // @ts-ignore
    //   const { title } = useGlobalContext();
    //   const [value, set] = title;

    //   //   @ts-ignore
    //   const setTitle = (data: Title[]) => set(data);

    //   return { setTitle, title: getTitle(value) };

    const {
        title: [dashboardTitle, setDashboardTitle]
    } = useGlobalContext() as DashboardTitle;

    useEffect(() => {
        if (defaultTitle) {
            setDashboardTitle([defaultTitle]);
        }
    // eslint-disable-next-line
  }, []);

    return { title: getTitle(dashboardTitle), setTitle: setDashboardTitle };
};
